export default {
  nav: {
    home: 'Inicio',
    categories: 'Categorías',
    shoppingGuide: 'Guía de compra',
    explore: 'Explorar la hoja',
  },
  hero: {
    badge: 'Recurso informativo independiente',
    title: 'USFans Spreadsheet — guía, lista de creadores e información clave',
    subtitle:
      'Una fuente organizada de guías, comparaciones y recursos sobre creadores, envíos, cupones y seguridad de USFans, todo en un solo lugar claro.',
    ctaSpreadsheet: 'USFans Spreadsheet',
    ctaBuy: 'Comprar ahora',
    mockupTitle: 'Hoja de creadores',
    mockupSearch: 'Buscar creadores...',
    mockupColCategory: 'Categoría',
    mockupColName: 'Nombre',
    mockupColStatus: 'Estado',
    mockupStatusActive: 'Activo',
    mockupStatusNew: 'Nuevo',
    mockupNote: 'Ordenado por categoría · filtrable',
  },
  trust: {
    title: '¿Por qué usar una hoja de USFans?',
    item1Title: 'Información actualizada',
    item1Desc: 'Mantenemos guías, comparaciones y recursos frescos y relevantes.',
    item2Title: 'Información clara',
    item2Desc: 'Organizada en categorías fáciles de explorar.',
    item3Title: 'La seguridad primero',
    item3Desc: 'Nunca compartas contraseñas, códigos de verificación ni datos sensibles.',
    item4Title: 'Guía independiente',
    item4Desc: 'Contenido informativo, no es un sitio oficial de USFans.',
  },
  categories: {
    title: 'Explorar por categoría',
    subtitle: 'Elige una categoría para ver la colección completa en nuestra tienda principal.',
    dropdownLabel: 'Elegir una categoría',
    dropdownHint: 'Selecciona una categoría para abrirla',
    items: {
      shoes: 'Zapatos',
      hoodies: 'Sudadera y jerséis',
      tshirts: 'Camisetas',
      jackets: 'Chaquetas',
      pants: 'Pantalones y shorts',
      headwear: 'Gorros',
      sets: 'Conjuntos',
      underwear: 'Ropa interior',
      jersey: 'Camisetas deportivas',
      accessories: 'Accesorios',
      bags: 'Bolsos',
      belts: 'Cinturones',
      perfumes: 'Perfumes',
      other: 'Otros',
    },
  },
  about: {
    title: '¿Qué es USFans Spreadsheet?',
    lead:
      'USFans Spreadsheet es una forma estructurada de explorar y organizar información sobre creadores, recursos y guías relacionadas con la plataforma USFans.',
    p1: 'Nuestro objetivo es ayudarte a encontrar lo que necesitas sin buscar en muchas páginas distintas. Con un diseño claro puedes comparar creadores, revisar categorías e ir directo a la fuente correcta más rápido.',
    p2: 'Las hojas son especialmente útiles para principiantes que quieren una visión general primero, antes de profundizar en creadores o recursos concretos.',
    listTitle: 'Beneficios clave:',
    list: [
      'Información organizada en un solo lugar',
      'Búsqueda y filtrado más rápidos',
      'Guías aptas para principiantes',
      'Comparaciones lado a lado',
      'Notas de seguridad actualizadas',
      'Estructura actualizable y compartible',
    ],
  },
  articleCta: {
    title: 'Lee la guía completa de USFans Spreadsheet',
    subtitle:
      'Descubre más sobre listas de creadores, directorios, comparaciones y consejos de seguridad en nuestra guía.',
    button: 'Abrir la guía',
  },
  articles: {
    title: 'Guías y recursos de USFans',
    subtitle: 'Guías detalladas sobre reseñas, envíos, cupones, almacén, seguridad y más.',
    readMore: 'Leer guía',
  },
  footer: {
    disclaimer:
      'USFansLink es un recurso informativo independiente y no está afiliado ni es operado por USFans.',
    rights: 'Todos los derechos reservados.',
    backHome: 'Inicio',
    mainSite: 'Visitar el sitio principal',
  },
};